import React from "react";

export default function LargeInput({ setSelected, value }) {
  return (
    <div className="w-full">
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[7.3rem] left-[9.7rem] md:left-[22.2rem] lg:top-[9.8rem] lg:left-[47.5rem]"
        maxLength={1}
        name="7"
        type="text"
        value={value.A1}
        onClick={() => setSelected("A1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5  lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[7.3rem] left-[11.8rem] md:left-[24.8rem] lg:top-[9.8rem] lg:left-[50.8rem]"
        maxLength={1}
        name="7"
        value={value.A2}
        onClick={() => setSelected("A2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[9.8rem] left-[15rem] md:left-[28.6rem] lg:top-[13.2rem] lg:left-[55.9rem]"
        maxLength={1}
        name="4"
        value={value.B3}
        onClick={() => setSelected("B3")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[9.8rem] left-[10.6rem] md:left-[23.4rem] lg:top-[13.2rem] lg:left-[49.05rem]"
        maxLength={1}
        name="74"
        value={value.B2}
        onClick={() => setSelected("B2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[9.8rem] left-[6.4rem] md:left-[18.3rem] lg:top-[13.2rem] lg:left-[42.2rem]"
        maxLength={1}
        name="6"
        value={value.B1}
        onClick={() => setSelected("B1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[18.4rem] md:left-[32.5rem] lg:top-[16.55rem] lg:left-[61rem]"
        maxLength={1}
        name="3"
        value={value.C8}
        onClick={() => setSelected("C8")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[16.2rem] md:left-[29.9rem] lg:top-[16.55rem] lg:left-[57.7rem]"
        maxLength={1}
        name="43"
        value={value.C7}
        onClick={() => setSelected("C7")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[13.9rem] md:left-[27.3rem]  lg:top-[16.55rem] lg:left-[54.3rem]"
        maxLength={1}
        name="24"
        value={value.C6}
        onClick={() => setSelected("C6")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[11.8rem] md:left-[24.8rem] lg:top-[16.55rem] lg:left-[50.9rem]"
        maxLength={1}
        name="42"
        value={value.C5}
        onClick={() => setSelected("C5")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[9.5rem] md:left-[22.2rem] lg:top-[16.55rem] lg:left-[47.3rem]"
        maxLength={1}
        name="74"
        value={value.C4}
        onClick={() => setSelected("C4")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[7.5rem] md:left-[19.6rem] lg:top-[16.55rem] lg:left-[43.9rem]"
        maxLength={1}
        name="67"
        value={value.C3}
        onClick={() => setSelected("C3")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[5.3rem] md:left-[17rem] lg:top-[16.55rem] lg:left-[40.4rem]"
        maxLength={1}
        name="36"
        value={value.C2}
        onClick={() => setSelected("C2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[12.35rem] left-[3rem] md:left-[14.5rem] lg:top-[16.55rem] lg:left-[37rem]"
        maxLength={1}
        name="3"
        value={value.C1}
        onClick={() => setSelected("C1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[14.85rem] left-[4rem] md:left-[15.7rem] lg:top-[19.9rem] lg:left-[38.7rem]"
        maxLength={1}
        name="35"
        value={value.D1}
        onClick={() => setSelected("D1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[14.85rem] left-[8.5rem] md:left-[20.8rem] lg:top-[19.9rem] lg:left-[45.6rem]"
        maxLength={1}
        name="72"
        value={value.D2}
        onClick={() => setSelected("D2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[14.85rem] left-[12.9rem] md:left-[26rem] lg:top-[19.9rem] lg:left-[52.5rem]"
        maxLength={1}
        name="25"
        value={value.D3}
        onClick={() => setSelected("D3")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[14.85rem] left-[17.3rem] md:left-[31.2rem] lg:top-[19.9rem] lg:left-[59.4rem]"
        maxLength={1}
        name="36"
        value={value.D4}
        onClick={() => setSelected("D4")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[18.3rem] md:left-[32.5rem] lg:top-[23.3rem] lg:left-[61rem]"
        maxLength={1}
        name="6"
        value={value.E8}
        onClick={() => setSelected("E8")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[16.1rem] md:left-[29.9rem] lg:top-[23.3rem] lg:left-[57.7rem]"
        maxLength={1}
        name="50"
        value={value.E7}
        onClick={() => setSelected("E7")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[13.95rem] md:left-[27.3rem] lg:top-[23.3rem] lg:left-[54.3rem]"
        maxLength={1}
        name="25"
        value={value.E6}
        onClick={() => setSelected("E6")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[11.8rem] md:left-[24.7rem] lg:top-[23.3rem] lg:left-[50.9rem]"
        maxLength={1}
        name="48"
        value={value.E5}
        onClick={() => setSelected("E5")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[9.6rem] md:left-[22.2rem] lg:top-[23.3rem] lg:left-[47.3rem]"
        maxLength={1}
        name="24"
        value={value.E4}
        onClick={() => setSelected("E4")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[7.4rem] md:left-[19.6rem] lg:top-[23.3rem] lg:left-[43.9rem]"
        maxLength={1}
        name="12"
        value={value.E3}
        onClick={() => setSelected("E3")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[5.3rem] md:left-[17rem] lg:top-[23.3rem] lg:left-[40.4rem]"
        maxLength={1}
        name="51"
        value={value.E2}
        onClick={() => setSelected("E2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[17.4rem] left-[3rem] md:left-[14.5rem] lg:top-[23.3rem] lg:left-[37rem]"
        maxLength={1}
        name="5"
        value={value.E1}
        onClick={() => setSelected("E1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[19.85rem] left-[15rem] md:left-[28.6rem] lg:top-[26.7rem] lg:left-[55.9rem]"
        maxLength={1}
        name="50"
        value={value.F3}
        onClick={() => setSelected("F3")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[19.85rem] left-[10.6rem] md:left-[23.4rem] lg:top-[26.7rem] lg:left-[49.05rem]"
        maxLength={1}
        name="48"
        value={value.F2}
        onClick={() => setSelected("F2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[19.85rem] left-[6.2rem] md:left-[18.3rem] lg:top-[26.7rem] lg:left-[42.2rem]"
        maxLength={1}
        name="13"
        value={value.F1}
        onClick={() => setSelected("F1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[22.42rem] left-[5.2rem] md:left-[17rem] lg:top-[30rem] lg:left-[40.4rem]"
        maxLength={1}
        name="3"
        value={value.G1}
        onClick={() => setSelected("G1")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[22.42rem] left-[7.4rem] md:left-[19.6rem] lg:top-[30rem] lg:left-[44rem]"
        maxLength={1}
        name="39"
        value={value.G2}
        onClick={() => setSelected("G2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[22.42rem] left-[9.6rem] md:left-[22.2rem] lg:top-[30rem] lg:left-[47.4rem]"
        maxLength={1}
        name="98"
        value={value.G3}
        onClick={() => setSelected("G3")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[22.42rem] left-[11.8rem] md:left-[24.7rem] lg:top-[30rem] lg:left-[50.9rem]"
        maxLength={1}
        name="86"
        value={value.G4}
        onClick={() => setSelected("G4")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[22.42rem] left-[13.95rem] md:left-[27.3rem] lg:top-[30rem] lg:left-[54.2rem]"
        maxLength={1}
        name="60"
        value={value.G5}
        onClick={() => setSelected("G5")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[22.42rem] left-[16.1rem] md:left-[29.9rem] lg:top-[30rem] lg:left-[57.7rem]"
        maxLength={1}
        name="0"
        value={value.G6}
        onClick={() => setSelected("G6")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[24.85rem] left-[13rem] md:left-[26rem] lg:top-[33.3rem] lg:left-[52.5rem]"
        maxLength={1}
        name="6"
        value={value.H2}
        onClick={() => setSelected("H2")}
        readOnly
      />
      <input
        className="text-center w-5 h-5 lg:w-6 lg:h-6 outline-black rounded-full flex justify-center items-center absolute z-10 bg-gray-300 top-[24.85rem] left-[8.5rem] md:left-[20.85rem] lg:top-[33.3rem] lg:left-[45.6rem]"
        maxLength={1}
        name="9"
        value={value.H1}
        onClick={() => setSelected("H1")}
        readOnly
      />
    </div>
  );
}
